import { inject, Injectable } from "@angular/core";
import {
  OpenIdConfiguration,
  provideAuth,
  StsConfigLoader,
  StsConfigStaticLoader,
} from "angular-auth-oidc-client";
import { WhiteLabelService } from "../core/util/white-label.service";

@Injectable({ providedIn: "root" })
export class AuthConfigService {
  private whiteLabelService = inject(WhiteLabelService);

  getAuthConfig(): OpenIdConfiguration {
    const conf: OpenIdConfiguration = {
      configId: "main",
      redirectUrl: this.whiteLabelService.appUrl,
      postLogoutRedirectUri: `${this.whiteLabelService.appUrl}/`,
      postLoginRoute: "",
      clientId: "client",
      // 'openid profile offline_access ' + your scopes
      scope: "openid email profile",
      responseType: "code",
      silentRenew: true,
      silentRenewUrl: `${this.whiteLabelService.appUrl}/assets/silent-renew.html`,
      // refresh tokens are to be used with confidential clients only. This web app is a public client.
      useRefreshToken: false,
      renewTimeBeforeTokenExpiresInSeconds: 30,
      renewUserInfoAfterTokenRenew: true,
      // Default is 120. This delay is to accomodate variations in clocks between the client and the server
      maxIdTokenIatOffsetAllowedInSeconds: 120,
      // This was added with 18.0.2 and breaks login if redirect URLs doe not match
      checkRedirectUrlWhenCheckingIfIsCallback: false,
    };

    let sso = "0";
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has("sso")) {
      sso = searchParams.get("sso");
    }

    conf.authority = this.whiteLabelService.authUrl;
    conf.customParamsAuthRequest = {
      labelId: this.whiteLabelService.id,
      sso: sso,
    };

    return conf;
  }
}

const authFactory = (authConfigService: AuthConfigService) => {
  const config = authConfigService.getAuthConfig();
  return new StsConfigStaticLoader(config);
};

export function provideAuthConfig() {
  return provideAuth({
    loader: {
      provide: StsConfigLoader,
      useFactory: authFactory,
      deps: [AuthConfigService],
    },
  });
}
